import { render, staticRenderFns } from "./InsuranceCards.vue?vue&type=template&id=9c5d6356"
import script from "./InsuranceCards.vue?vue&type=script&lang=js"
export * from "./InsuranceCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports